import moment from 'moment';

const TICKS_AT_UNIX_EPOCH = 621355968000000000;
const TICKS_PER_SECOND = 10000000;

moment.fn.ticks = function ticks() {
    return (this.unix() * TICKS_PER_SECOND) + TICKS_AT_UNIX_EPOCH;
};
